import React from 'react';

import { twMerge } from 'tailwind-merge';

interface Props {
  id?: string;
  children?: React.ReactNode;
  onClick: (event: React.MouseEvent) => void;
  variant?: 'primary' | 'secondary' | 'danger';
  className?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
}

export default function Button({ id, children, onClick, variant = 'primary', className, type, disabled }: Props) {
  const variantToClass = {
    primary: 'bg-blue-500 text-white rounded-md px-4 py-2 shadow-sm flex-1 hover:bg-blue-600',
    danger: 'bg-red-500 text-white rounded-md px-4 py-2 shadow-sm flex-1 hover:bg-red-600',
    secondary:
      'border border-gray-300 bg-white text-gray-700 rounded-md py-1.5 px-3 flex-1 shadow-sm hover:text-gray-500',
  };

  function handleClick(event) {
    event?.preventDefault();
    onClick(event);
  }

  return (
    <button
      id={id ?? "button_id"}
      type={type}
      disabled={disabled}
      onClick={handleClick}
      className={twMerge(
        'z-50 text-sm leading-5 font-medium rounded-md py-1.5 px-3 flex-1',
        variantToClass[variant],
        className
      )}
    >
      {children}
    </button>
  );
}
